module.exports = __webpack_public_path__ + "static/media/checklist_footer.499dd6db.jpg";